import { useEffect, useState, useRef } from 'react';
import Input from '../Common/Input';
import ReactSelect from 'react-select';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import AvatarEditor from 'react-avatar-editor';
import InputRange from 'react-input-range';

const Form = ({ formik, showParent = true }) => {

    const [guilds,setGuilds] = useState([]);
    const {readData} = useEntityCrud('Guild/GetAllGuilds');

    const editor = useRef();
    const [imageSrc, setImageSrc] = useState('');
    const [zoom, setZoom] = useState(1.5);
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    const [radius, setRadius] = useState(0);

    const getData = () => {
        readData().then(({data}) => {
            if(data.status){
                let generateGuilds = [];
                data.result.map(item => {
                    generateGuilds.push({
                        label: item.title,
                        value: item.id
                    });
                })
                setGuilds(generateGuilds);
            }
        });
    }

    useEffect(() => {
        getData();
    },[]);

    const toBase64 = async file => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    const setCurrentFile = async e => {
        const file = e.target.files[0];
        const fileData = await toBase64(file);
        setWidth(50)
        setHeight(50)
        setRadius(0)
        setImageSrc(fileData);
    }

    const downloadImageCropped = () => {
        if(editor){
            const imageData = editor.current.getImageScaledToCanvas().toDataURL('image/png');
            formik.setFieldValue('icon',imageData)
            setTimeout(() => {
                setImageSrc('');
                setZoom(1.5);
                setRadius(0);
                document.getElementById('modal-file-input').value = '';
            }, 300)
        }
    }

    const downloadImage = base64 => {
        let image = new Image();
        image.src = base64;
        let newWindow = window.open('');
        newWindow.document.write(image.outerHTML);
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="modal fade" id="uploadImage" tabindex="-1" aria-labelledby="uploadImageLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="uploadImageLabel">بارگذاری تصویر</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="fa fa-close"></i></button>
                        </div>
                        <div className="modal-body text-center">
                            <div className={`row ${imageSrc ? 'mb-2' : ''}`}>
                                <div className="col-md-6">
                                    <div className="form-group text-start">
                                        <label>انتخاب تصویر</label>
                                        <input type="file" id="modal-file-input" className="form-control" accept="image/jpeg,image/png" onChange={e => setCurrentFile(e)} />
                                    </div>
                                </div>
                            </div>
                            {!!imageSrc && <>
                                <AvatarEditor ref={editor} image={imageSrc} width={width} height={height} border={20} color={[255, 255, 255, 0.5]} scale={zoom} rotate={0} borderRadius={radius} />
                                <p className="mt-3 text-start">زوم</p>
                                <div dir="ltr" className="mt-1 mb-4"><InputRange maxValue={10} step={0.5} minValue={1} value={zoom} onChange={value => setZoom(value)} /></div>
                            </>}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal">لغو</button>
                            {!!imageSrc && <button type="button" className="btn btn-primary" onClick={downloadImageCropped} data-bs-dismiss="modal">بارگذاری تصویر</button>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3">
                    <Input label="عنوان" name="title" required={true} formik={formik} />
                </div>
                {showParent && <div className="col-md-2">
                    <div className="form-group">
                        <label>صنف والد</label>
                        <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید"
                         options={guilds} value={guilds.filter(item => item.value == formik.values.guildId)} onChange={e => formik.setFieldValue('guildId', e.value)} />
                    </div>
                </div>}
                {!formik.values.guildId && <div className="col-md-2">
                    {formik.values.icon ? <small className="text-primary" style={{ float: 'left' }} onClick={() => downloadImage(formik.values.icon)}>مشاهده تصویر</small> : ''}
                    {!formik.values.icon && formik.values.iconPath ? <small className="text-primary" style={{ float: 'left' }} onClick={() => window.open(`https://petromah.sabinarya.com${formik.values.iconPath}`)}>مشاهده تصویر</small> : ''}
                    <button type="button" className="btn btn-primary w-100 mb-3" style={{marginTop: formik.values.icon || formik.values.iconPath ? 12 : 29}} data-bs-toggle="modal" data-bs-target="#uploadImage">بارگذاری آیکون</button>
                </div>}
            </div>
            <button className="btn btn-success" id="btn-submit-form">ذخیره اطلاعات</button>
        </form>
    );
}

export default Form;